import React from "react";
import { render } from "react-dom";
import App from "../components/App";

const event =
  window.Turbolinks != undefined && window.Turbolinks.supported
    ? "turbolinks:load"
    : "DOMContentLoaded";

document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("root");
  render(<App dateOffset={root.dataset.offset} />, root);
});



// WEBPACK FOOTER //
// ./app/javascript/packs/application.jsx